function triggerBrowserDownload(url, fileName) {
    const anchor = document.createElement('a');
    anchor.href = url;
    if (fileName) {
        anchor.download = fileName;
    }
    anchor.rel = 'noopener';
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
}

export async function downloadSignedFile(url, fileName, signal) {
    const response = await fetch(url, {signal});
    if (!response.ok) {
        throw new Error(`Failed to download ${fileName || 'file'}`);
    }
    const blob = await response.blob();
    const downloadUrl = window.URL.createObjectURL(blob);
    triggerBrowserDownload(downloadUrl, fileName);
    window.setTimeout(() => window.URL.revokeObjectURL(downloadUrl), 1000);
    return blob.size || 0;
}


export function supportsDirectoryDownloads() {
    return typeof window !== 'undefined' && typeof window.showDirectoryPicker === 'function';
}

// Streams one file to <directoryHandle>/<pathParts...>, creating subfolders as needed.
export async function downloadSignedFileToDirectory(url, directoryHandle, pathParts, signal) {
    const parts = pathParts.map(String).filter((part) => part && part !== '.' && part !== '..');
    if (!parts.length) throw new Error('Invalid file path.');
    const response = await fetch(url, {signal});
    if (!response.ok || !response.body) {
        throw new Error(`Failed to download ${parts.join('/')}`);
    }
    let directory = directoryHandle;
    for (const part of parts.slice(0, -1)) {
        directory = await directory.getDirectoryHandle(part, {create: true});
    }
    const fileHandle = await directory.getFileHandle(parts[parts.length - 1], {create: true});
    const writable = await fileHandle.createWritable();
    await response.body.pipeTo(writable, {signal});
    return Number(response.headers.get('content-length')) || 0;
}
